import  { FC } from "react";
import StayDatesRangeInput from "./StayDatesRangeInput";
import { useNavigate } from "react-router-dom";
import DetailPagetLayout from "../Layout";
import GuestsInput from "./GuestsInput";
import RoomTable from "components/RoomsTable/RoomsTable";
import StayDatesRangeInputView from "./StayDatesRangeInputView";
import GuestsInputView from "./GuestsInputView";
import  useFetch  from "hooks/useFetch";
import config from "config.json";
import { useState,useEffect } from "react";
import SectionHotelData from "../(components)/SectionHotelData";

interface HotelImage {
  hotel_code: string;
  photos: string[];
}

interface HotelImageDataResponse {
  default_image: string;
  hoteles: HotelImage[];
}
const StayDetailPageContainer: FC<{}> = () => {

  const router = useNavigate();
  const hotelCode = sessionStorage.getItem("selected_hotel");

  
  const renderSidebar = () => {

    const handleBack = () => {
     sessionStorage.removeItem("roomsData");
      router('/listing-stay-detail', { replace: true });
      sessionStorage.removeItem("dates_adjusted")
    }
    
    

    return (
      <div className="listingSectionSidebar__wrap shadow-xl">
        {/* PRICE */}
        <div className="flex justify-between">
          <span className="text-3xl font-semibold">
            Reserva:
            {/* <span className="ml-1 text-base font-normal text-neutral-500 dark:text-neutral-400">
              /night
            </span> */}
          </span>
          {/* <StartRating /> */}
        </div>
        {/*seccion de info hotel*/}
        <SectionHotelData hotelCode={hotelCode}/>
        {/* FORM */}
        <form className="flex flex-col border border-neutral-200 dark:border-neutral-700 rounded-3xl ">
          <StayDatesRangeInputView className="flex-1 z-[11]" />
          <div className="w-full border-b border-neutral-200 dark:border-neutral-700"></div>
          <GuestsInputView className="flex-1" />
        </form>
        {/* SUBMIT */}
        <button onClick={handleBack} className=" border bg-white-6000 hover:bg-neutral-200  text-red-500 py-2 px-4 rounded-full mt-4 w-full">Volver</button>
      </div>
    );
  }

  return (
    <div className="nc-ListingStayDetailPage">

      {/* MAIN */}
      <main className=" relative z-10 mt-11 flex flex-col lg:flex-row ">

        <div className="lg:hidden mb-4">
          <div className="sticky top-28">{renderSidebar()}</div>
        </div>
        {/* CONTENT */}
        <div className="w-full lg:w-3/5 xl:w-2/3 space-y-8 lg:space-y-10 lg:pr-10">
         
        <RoomTable />
         
        </div>

        {/* SIDEBAR */}
        <div className="hidden lg:block flex-grow mt-14 lg:mt-0">
          <div className="sticky top-28">{renderSidebar()}</div>
        </div>
      </main>
    </div>
  );
};

export default function ListingStayDetailPage() {
  return (
    <DetailPagetLayout>
      <StayDetailPageContainer />
    </DetailPagetLayout>
  );
}
